module.exports = __webpack_public_path__ + "img/arrowright.daba969d.svg";